import { apiClient } from '../api-client';

export const updateVacationRequestStatus = async (getToken, requestId, newStatus, note = null) => {
  const result = await apiClient('POST', `/requests/vacation/${requestId}/status`, getToken, {
    status: newStatus,
    ...(note !== null ? { note } : {}),
  });

  if (result?.status === 'error') {
    throw new Error(result.message || 'Request failed');
  }

  return result;
};

export const createVacationRequest = async (getToken, { startDate, endDate, description }) =>
  apiClient('POST', '/requests/vacation', getToken, {
    startDate,
    endDate,
    description,
  });
